<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="text-h6">Servicios</span>
        <v-spacer></v-spacer>

        <v-btn
          class="mr-4"
          title="Agregar Servicio"
          small
          color="primary"
          @click="$emit('changeView', 'nuevo')"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          class="mr-4"
          small
          title="Calendario de Sevicios"
          color="primary"
          @click="$emit('changeView', 'calendario')"
        >
          <v-icon>mdi-calendar-month</v-icon>
        </v-btn>
        <!-- AGREGAR BTN PARA IR A DIFERENTES VISTAS -->
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="services"
        item-value="id"
        dense
        class="px-3 elevation-1 custom-table"
        :search="search"
        :custom-filter="customFilter"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Buscar"
            outlined
            dense
            class="mx-4 small-input"
          ></v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex align-center">
            <v-icon
              v-if="item.status !== 'pendiente'"
              title="Imprimir"
              @click="printCheckin(item)"
              left
              color="blue darken-2"
            >
              mdi-printer
            </v-icon>
            <v-icon
              v-if="item.status == 'pendiente'"
              :disabled="!item.vehicle.plate"
              title="Iniciar Check In"
              @click="initCheckIn(item)"
              left
              color="blue darken-2"
            >
              mdi-car-key
            </v-icon>
            <v-icon
              v-if="item.status == 'pendiente'"
              title="Editar fecha de servicio"
              color="orange darken-2"
              class="ml-1"
              @click="openEditServiceDate(item)"
            >
              mdi-calendar-edit
            </v-icon>
            <v-icon
              v-if="item.status == 'en proceso'"
              title="Pasar a Listo para Retirar"
              color="success"
              @click="openDialogConfirmService(item)"
            >
              mdi-checkbox-marked-circle-outline
            </v-icon>
            <v-icon
              v-if="item.status == 'listo' || item.status == 'finalizado'"
              title="Ver Servicio"
              @click="openServiceModal(item)"
              left
              color="blue darken-2"
              >mdi-eye</v-icon
            >
            <v-icon
              v-if="item.status == 'pendiente' && !item.vehicle.plate"
              title="Agregar Patente"
              @click="openServiceUpdatePlate(item)"
              left
              color="blue darken-2"
            >
              mdi-pencil
            </v-icon>
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            small
            :color="colorsStatus[item.status]"
            text-color="white"
            class="ma-2"
          >
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:item.client.email="{ item }">
          <div :title="item.client.email">
            {{ item.client.email }}
          </div>
        </template>
        <template v-slot:item.client="{ item }">
          <div
            :title="`${item.client.first_name} ${item.client.last_name ?? ''}`"
          >
            {{ `${item.client.first_name} ${item.client.last_name ?? ""}` }}
          </div>
        </template>
        <template v-slot:item.remainingDays="{ item }">
          <v-chip
            small
            outlined
            :color="getStatusColor(item)"
            dark
          >
            {{ item.remainingDays }} día(s)
          </v-chip>
        </template>
        <template v-slot:item.startTimestamp="{ item }">
          {{ item.start }}
        </template>
        <template v-slot:item.client.phone="{ item }">
          <div>
            <a
              v-if="isValidPhoneNumber(item.client.phone)"
              :href="getWhatsAppLink(item.client.phone)"
              target="_blank"
              rel="noopener"
              :title="`Contactar a ${item.client.first_name} por WhatsApp`"
            >
              {{ item.client.phone }}
              <v-icon small color="green darken-1" class="ml-1"
                >mdi-whatsapp</v-icon
              >
            </a>

            <span v-else>
              {{ item.client.phone }}
            </span>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000">
      {{ snackbar.text }}
      <v-btn text @click="snackbar.show = false">Cerrar</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialogConfirmService" max-width="800px">
      <v-card>
        <v-card-title class="headline">
          Confirmar finalización de servicio
        </v-card-title>
        <v-col class="pb-3">
          Tareas agregadas
          <v-row class="pa-3">
            <v-col cols="12" md="6" class="text-center pl-1 pr-1 pb-1">
              <v-text-field
                v-model="request"
                label="Solicitud"
                outlined
                dense
                hide-details
                :disabled="requests.length >= countRequest"
              />
            </v-col>

            <v-col cols="8" md="4" class="text-center pl-1 pr-1 pb-1">
              <v-text-field
                v-model="approximateBudget"
                label="Presupuesto aproximado"
                outlined
                dense
                hide-details
                type="number"
                :disabled="requests.length >= countRequest"
              />
            </v-col>

            <v-col cols="4" md="2" class="text-center pl-1 pr-1 pb-1">
              <v-btn
                :disabled="requests.length >= countRequest"
                color="info"
                @click="addRequest()"
                block
              >
                Agregar
              </v-btn>
            </v-col>

            <!-- Campos dinámicos agregados por plantilla -->
            <v-col v-for="(field, i) in requests" :key="i" cols="12 pb-0 pt-0">
              <v-chip
                class="ma-2"
                color="info"
                outlined
                style="max-width: 100%; overflow-wrap: break-word"
              >
                <v-icon color="red" left @click="requests.splice(i, 1)">
                  mdi-delete
                </v-icon>
                {{ `${field.request} - ${field.approximateBudget}` }}
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
        <v-divider></v-divider>
        <!--v-card-text>
          ¿Estás seguro que querés marcar este servicio como
          <strong>"Listo para retirar"</strong>?
        </v-card-text-->
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text color="grey" @click="dialogConfirmService = false">
            Cancelar
          </v-btn>

          <v-btn color="success" @click="confirmService()"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogServiceDetails" max-width="800px">
      <v-card>
        <v-card-title class="headline"
          >Detalle del Servicio #{{ serviceSelected.id }}</v-card-title
        >
        <v-card-text>
          <v-container>
            <v-row class="pb-3">
              <!-- Datos generales -->
              <v-col cols="12" sm="6"
                ><strong>Estado:</strong> {{ serviceSelected.status }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Servicio:</strong>
                {{
                  serviceSelected.template ? serviceSelected.template.name : "—"
                }}
              </v-col>
              <v-col cols="12" sm="6"
                ><strong>Fecha Recepción:</strong>
                {{ serviceSelected.date_received }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Fecha Entrega:</strong>
                {{ serviceSelected.date_delivered }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Inicio Técnico:</strong>
                {{ serviceSelected.start }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Fin Técnico:</strong> {{ serviceSelected.end }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Recepcionado por:</strong>
                {{ serviceSelected.receiver }}</v-col
              >
              <!--v-col cols="12" sm="6"
                ><strong>Fecha de recepción:</strong>
                {{ serviceSelected.date_received }}</v-col
            -->
            </v-row>

            <v-divider></v-divider>
            <v-row class="pb-3">
              <!-- Datos del cliente -->
              <v-col cols="12"><h3 class="subtitle-1 mt-4">CLIENTE</h3></v-col>
              <v-col cols="12" sm="6"
                ><strong>Nombre:</strong>
                {{ serviceSelected.client.first_name }}
                {{ serviceSelected.client.last_name }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>CUIT:</strong> {{ serviceSelected.client.cuit }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Correo:</strong>
                {{ serviceSelected.client.email }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Teléfono:</strong>
                {{ serviceSelected.client.phone }}</v-col
              >
            </v-row>
            <v-divider></v-divider>
            <v-row class="pb-3">
              <!-- Datos del vehículo -->
              <v-col cols="12"><h3 class="subtitle-1 mt-4">VEHÍCULO</h3></v-col>
              <v-col cols="12" sm="6"
                ><strong>Marca:</strong>
                {{ serviceSelected.vehicle.make }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Modelo:</strong>
                {{ serviceSelected.vehicle.model }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Año:</strong> {{ serviceSelected.vehicle.year }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Patente:</strong>
                {{ serviceSelected.vehicle.plate }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Número de chasis:</strong>
                {{ serviceSelected.vehicle.chassis_number }}</v-col
              >
              <v-col cols="12" sm="6"
                ><strong>Número de motor:</strong>
                {{ serviceSelected.vehicle.motor_number }}</v-col
              >
            </v-row>
            <v-divider></v-divider>
            <v-row class="pb-3">
              <!-- Checkboxes / Flags -->
              <v-col cols="12"><h3 class="subtitle-1 mt-4">TAREAS</h3></v-col>
              <v-col cols="12" class="pa-0">
                <v-list dense>
                  <v-list-item
                    v-for="tsk in serviceSelected.service_lines"
                    :key="tsk.id"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{
                        tsk.observation
                      }}</v-list-item-title>
                      <v-list-item-subtitle v-if="tsk.value"
                        >Valor: {{ tsk.value }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="6" sm="4" v-for="flag in flags" :key="flag.key">
                <v-checkbox
                  :label="flag.label"
                  :value="serviceSelected[flag.key]"
                  :input-value="serviceSelected[flag.key]"
                  readonly
                  disabled
                  hide-details
                />
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="pb-3">
              <!-- Observaciones -->
              <v-col cols="12"
                ><h3 class="subtitle-1 mt-4">OBSERVACIONES</h3></v-col
              >
              <v-col cols="12" class="pa-0">
                <v-list dense>
                  <v-list-item
                    v-for="obs in serviceSelected.observations"
                    :key="obs.id"
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{
                        obs.observation
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions
          v-if="serviceSelected.status != 'finalizado'"
          class="pa-4"
        >
          <v-btn color="primary" @click="dialogServiceDetails = false"
            >Cerrar</v-btn
          >
          <v-spacer />
          <v-btn color="success" @click="confirmService()">Finalizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogServiceUpdatePlate" max-width="800px">
      <v-card>
        <v-card-title class="headline">Agregar Patente</v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" @submit.prevent="updateVehiclePlate">
              <v-text-field
                v-model="plate"
                label="Patente"
                outlined
                dense
                required
              ></v-text-field>
              <v-card-actions class="pa-4">
                <v-btn color="primary" @click="dialogServiceUpdatePlate = false"
                  >Cerrar</v-btn
                >
                <v-spacer />
                <v-btn
                  color="success"
                  type="submit"
                  :disabled="plate.length < 1"
                  >Finalizar</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Diálogo para editar fecha -->
    <v-dialog v-model="dialogEditDate" max-width="400px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Editar Fecha de Servicio
        </v-card-title>

        <v-card-text>
          <v-form ref="formDate" v-model="formValid" lazy-validation>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedDate"
                  label="Nueva fecha de servicio"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="[(v) => !!v || 'La fecha es obligatoria']"
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="editedDate"
                locale="es-AR"
                @input="updateFormattedDate"
              ></v-date-picker>
            </v-menu>

            <!-- Campo para la hora -->
            <v-text-field
              v-model="editedTime"
              label="Hora de servicio"
              type="time"
              prepend-icon="mdi-clock-outline"
              :rules="[(v) => !!v || 'La hora es obligatoria']"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="closeEditDateDialog">Cancelar</v-btn>
          <v-btn
            color="primary"
            :disabled="!formValid"
            @click="saveServiceDate"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" :z-index="3000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
  
  <script>
import axios from "@/plugins/axios.js";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

export default {
  data() {
    return {
      snackbar: {
        show: false,
        text: "",
        color: "success",
      },
      countRequest: 6,
      requests: [],
      approximateBudget: null,
      request: null,
      plate: "",
      dialogServiceUpdatePlate: false,
      dialogServiceDetails: false,
      dialogConfirmService: false,
      serviceSelected: {
        id: null,
        km_in: null,
        km_out: null,
        observation: null,
        type: null,
        start: null,
        end: null,
        status: null,
        template_id: null,
        company_id: null,
        client_id: null,
        vehicle_id: null,
        created_at: null,
        updated_at: null,
        deleted_at: null,
        has_green_card: 0,
        has_warranty_manual: 0,
        has_invoice_a: 0,
        has_insurance: 0,
        is_vehicle_dirty: 0,
        has_belongings: 0,
        removes_used_parts: 0,
        fuel_in: null,
        has_test_drive: 0,
        has_turn: 0,
        receiver: null,
        date_received: null,
        client: {
          id: null,
          dni: null,
          last_name: null,
          email: null,
          phone: null,
          address: null,
          created_at: null,
          updated_at: null,
          first_name: null,
          cuit: null,
        },
        vehicle: {
          id: null,
          make: null,
          body_type: null,
          model: null,
          year: null,
          color: null,
          chassis_make: null,
          chassis_number: null,
          motor_number: null,
          motor_make: null,
          plate: null,
          client_id: null,
          status: null,
          created_at: null,
          updated_at: null,
          certificate_number: null,
        },
        template: {
          id: null,
          name: null,
          description: null,
          created_at: null,
          updated_at: null,
        },
        observations: [],
        service_lines: [],
        marks: [],
      },
      flags: [
        { key: "has_green_card", label: "Cédula verde" },
        { key: "has_warranty_manual", label: "Manual de garantía" },
        { key: "has_invoice_a", label: "Factura A" },
        { key: "has_insurance", label: "Seguro" },
        { key: "is_vehicle_dirty", label: "Vehículo sucio" },
        { key: "has_belongings", label: "Con pertenencias" },
        { key: "removes_used_parts", label: "Retira piezas usadas" },
        { key: "has_test_drive", label: "Prueba de manejo" },
        { key: "has_turn", label: "Con turno" },
      ],
      colorsStatus: {
        pendiente: "",
        "en proceso": "primary",
        listo: "warning",
        finalizado: "green",
      },
      search: "",
      dialog: false,
      dialogTitle: "",
      headers: [
        { text: "#", value: "id" },
        { text: "CLIENTE", value: "clientFullName" },
        { text: "CORREO", value: "client.email" },
        { text: "TELÉFONO", value: "client.phone" },
        { text: "VEHICULO", value: "vehicle.model" },
        { text: "PATENTE", value: "vehicle.plate" },
        { text: "TIEMP.REST", value: "remainingDays", align: "center" },
        {
          text: "ESTADO",
          value: "status",
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      services: [], // Aquí se cargan los datos de usuarios desde la API
      user: {
        id: null,
        name: "",
        rol: 0,
        email: "",
        password: "",
      },
      action: "", // 'add' o 'edit'
      overlay: false,
      roles: [],
      serviceUpdatePlate: null,
      dialogEditDate: false,
      editedDate: null, // formato real (yyyy-mm-dd)
      editedTime: null, // formato real (hh:mm)
      formattedDate: null, // lo que se muestra (dd/mm/yyyy)
      formValid: false,
      menu: false,
    };
  },
  mounted() {
    this.getServices();
  },
  methods: {
    getStatusColor(item) {
      if (item.status === "finalizado") return "#e0e0e0"; // gris claro
      if (item.remainingDays <= 1) return "red";
      return "green";
    },
    openEditServiceDate(item) {
      this.selectedService = item;

      if (item.start) {
        // Separar fecha y hora si la hay
        const [datePart, timePart] = item.start.split(" ");
        // Normalizar fecha
        if (datePart.includes("/")) {
          const [d, m, y] = datePart.split("/");
          this.editedDate = `${y}-${m}-${d}`;
        } else {
          this.editedDate = datePart;
        }
        // Si existe hora, tomarla; si no, usar "00:00"
        this.editedTime = timePart ? timePart.substring(0, 5) : "00:00";
      } else {
        this.editedDate = this.todayISO();
        this.editedTime = "00:00";
      }

      this.updateFormattedDate(this.editedDate);
      this.dialogEditDate = true;
    },
    closeEditDateDialog() {
      this.dialogEditDate = false;
      this.selectedService = null;
      this.editedDate = null;
      this.editedTime = null;
      this.formattedDate = null;
    },
    updateFormattedDate(date) {
      if (!date) return;
      // Quitar hora si la hay
      const [datePart] = date.split(" ");
      // Si la fecha es ISO (yyyy-mm-dd)
      if (datePart.includes("-")) {
        const [y, m, d] = datePart.split("-");
        this.formattedDate = `${d}/${m}/${y}`;
      }
      // Si viene en formato dd/mm/yyyy
      else if (datePart.includes("/")) {
        const [d, m, y] = datePart.split("/");
        this.formattedDate = `${d}/${m}/${y}`;
      }
    },
    todayISO() {
      return new Date().toISOString().split("T")[0]; // yyyy-mm-dd
    },
    saveServiceDate() {
      if (!this.$refs.formDate.validate()) return;
      // Combinar fecha y hora en formato ISO
      const isoDateTime = `${this.editedDate} ${this.editedTime}:00`;
      axios
        .put(`/services/editDateService`, {
          newDate: isoDateTime,
          serviceId: this.selectedService.id,
        })
        .then(() => {
          this.snackbar = {
            show: true,
            text: "Fecha y hora de servicio actualizadas correctamente",
            color: "success",
          };
          this.selectedService.start = `${this.formattedDate} ${this.editedTime}:00`;
          this.closeEditDateDialog();
        })
        .catch(() => {
          this.snackbar = {
            show: true,
            text: "Error al actualizar la fecha",
            color: "error",
          };
        });
    },
    addRequest() {
      if (this.request) {
        this.requests.push({
          request: this.request,
          approximateBudget: this.approximateBudget,
        });
        this.request = null;
        this.approximateBudget = null;
      }
    },
    isValidPhoneNumber(phone) {
      if (!phone || typeof phone !== "string") return false;
      const clean = phone.replace(/[^0-9]/g, "");
      return clean.length >= 10 && /^\d+$/.test(clean);
    },
    getWhatsAppLink(phone) {
      if (!phone || typeof phone !== "string") return null;
      const clean = phone.replace(/[^0-9]/g, "");
      if (!this.isValidPhoneNumber(phone)) return null;
      return `https://wa.me/${clean}`;
    },
    customFilter(value, search, item) {
      if (!search) return true;
      search = search.toLowerCase();
      const fullName = `${item.client?.first_name ?? ""} ${
        item.client?.last_name ?? ""
      }`.toLowerCase();
      const email = item.client?.email?.toLowerCase() ?? "";
      const phone = item.client?.phone?.toLowerCase() ?? "";
      const model = item.vehicle?.model?.toLowerCase() ?? "";
      const plate = item.vehicle?.plate?.toLowerCase() ?? "";
      const status = item.status?.toLowerCase() ?? "";
      const rawDate = item.start?.toLowerCase() ?? "";
      const rawDateEnd = item.end?.toLowerCase() ?? "";
      const remainingDays = this.getRemainingDays(item.start).toString();
      return (
        fullName.includes(search) ||
        email.includes(search) ||
        phone.includes(search) ||
        model.includes(search) ||
        plate.includes(search) ||
        status.includes(search) ||
        rawDate.includes(search) ||
        rawDateEnd.includes(search) ||
        remainingDays.includes(search)
      );
    },
    updateVehiclePlate() {
      this.overlay = true;
      axios
        .put("/vehicles/updatePlate", {
          id: this.serviceUpdatePlate.vehicle.id,
          plate: this.plate,
        })
        .then((response) => {
          if ((response.status = 200)) {
            this.overlay = false;
            this.dialogServiceUpdatePlate = false;
            this.serviceUpdatePlate = null;
            this.getServices();
          }
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    openServiceUpdatePlate(service) {
      this.dialogServiceUpdatePlate = true;
      this.serviceUpdatePlate = service;
    },
    openServiceModal(service) {
      this.serviceSelected = service;
      this.dialogServiceDetails = true;
    },
    confirmService() {
      this.dialogConfirmService = false;
      this.overlay = true;
      axios
        .post("/services/confirmService", {
          id: this.serviceSelected.id,
          requests: this.requests,
        })
        .then((response) => {
          this.dialogServiceDetails = false;
          this.overlay = false;
          this.requests = [];
          this.request = null;
          this.approximateBudget = null;
          this.getServices();
        })
        .catch((err) => {
          this.overlay = false;
          //this.msjModal = "Error! " + err;
          //this.$refs["msj-modal"].show();
        });
    },
    openDialogConfirmService(service) {
      this.serviceSelected = service;
      this.dialogConfirmService = true;
    },
    formatDate(dateString) {
      if (!dateString) return "-";

      const date = new Date(dateString.replace(" ", "T")); // Soporta "YYYY-MM-DD hh:mm"
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = String(date.getFullYear()).slice(-2);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    getRemainingDays(dateString) {
      // Separar fecha y hora
      const [datePart, timePart] = dateString.split(" ");
      const [day, month, year] = datePart.split("/").map(Number);
      const [hours = 0, minutes = 0, seconds = 0] =
        timePart?.split(":").map(Number) ?? [];
      // Crear fecha en formato válido (año ajustado si viene en 2 dígitos)
      const fullYear = year < 100 ? 2000 + year : year;
      const targetDate = new Date(
        fullYear,
        month - 1,
        day,
        hours,
        minutes,
        seconds
      );
      const now = new Date();
      const diffInMs = targetDate - now;
      const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      return diffInDays;
    },
    async printCheckin(service) {
      // 1. Cargar PDF base desde assets o endpoint
      const existingPdfBytes = await fetch("/MODELO_DE_PRE_ORDEN.pdf").then(
        (res) => res.arrayBuffer()
      );
      // 2. Cargar documento
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      // 3. Definir fuente y estilo
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const { width, height } = firstPage.getSize();
      // RESPONSABLE DE RECEPCIÓN
      this.drawTextAt(firstPage, service.receiver, 338, height - 27, font);
      // RESPONSABLE DE ENTREGA
      service.delivered_by &&
        this.drawTextAt(
          firstPage,
          service.delivered_by,
          485,
          height - 27,
          font
        );
      if (service.date_received) {
        // FECHA
        const [fecha, time] = service.date_received.split(" ");
        this.drawDate(firstPage, fecha, height, font);
        // HORA
        this.drawTime(firstPage, time, height, font);
      }
      if (service.date_delivered) {
        const [fechaDelivered, timeDelivered] =
          service.date_delivered.split(" ");
        // FECHA ESTIMADA DE ENTREGA
        this.drawDateDelivered(firstPage, fechaDelivered, height, font);
        // HORA ESTIMADA DE ENTREGA
        this.drawTimeDelivered(firstPage, timeDelivered, height, font);
      }
      if (service.estimated_date_delivered) {
        const [fechaDelivered, timeDelivered] =
          service.estimated_date_delivered.split(" ");
        // FECHA ESTIMADA DE ENTREGA
        this.drawDateEstimated(firstPage, fechaDelivered, height, font);
        // HORA ESTIMADA DE ENTREGA
        this.drawTimeEstimated(firstPage, timeDelivered, height, font);
      }
      // HORA TÉCNICO
      const hourMinute = service.start.split(" ")[1].substring(0, 5);
      this.technicianStart(firstPage, hourMinute, height, font);
      // HORA TÉCNICO FIN
      if (service.status == "listo" || service.status == "finalizado") {
        const hourMinuteEnd = service.end.split(" ")[1].substring(0, 5);
        this.technicianEnd(firstPage, hourMinuteEnd, height, font);
      }
      // CLIENTE
      this.drawClientInfo(firstPage, service.client, height, font);
      // VEHÍCULO
      this.drawVehicleInfo(
        firstPage,
        service.vehicle,
        service.km_in,
        height,
        font
      );
      // CÍRCULOS DE DOCUMENTACIÓN
      this.drawCircleOption(
        firstPage,
        service.has_turn,
        130,
        164,
        height - 208,
        6
      );
      this.drawCircleOption(
        firstPage,
        service.has_test_drive,
        301,
        335,
        height - 208,
        6
      );
      this.drawCircleOption(
        firstPage,
        service.has_green_card,
        267,
        301,
        height - 146,
        6
      );
      this.drawCircleOption(
        firstPage,
        service.has_warranty_manual,
        327,
        369,
        height - 146,
        6
      );
      this.drawCircleOption(
        firstPage,
        service.has_invoice_a,
        393,
        429,
        height - 146,
        6
      );
      this.drawCircleOption(
        firstPage,
        service.has_insurance,
        504,
        538,
        height - 146,
        6
      );
      // TRABAJOS
      if (service.service_lines.length > 0) {
        this.drawRequests(firstPage, service.service_lines, height, font);
      }
      // OBSERVACIONES
      if (service.observations.length > 0) {
        this.drawObservations(firstPage, service.observations, height, font);
      }
      const vehicleState = {
        isVehicleDirty: service.is_vehicle_dirty,
        hasBelongings: service.has_belongings,
        removesUsedParts: service.removes_used_parts,
      };
      // ESTADO DEL VEHÍCULO
      this.drawVehicleStateOptions(firstPage, vehicleState, height);

      // 4. Dibujar las marcas en el PDF
      const circleRadius = 5; // tamaño del círculo
      const imageContainerWidth = 178; // ancho en el que se mostró la imagen en pantalla
      const imageContainerHeigh = 181; // ancho en el que se mostró la imagen en pantalla
      for (const mark of service.marks) {
        //const posX = (mark.x / 100) * imageContainerWidth;
        const posX = mark.x * 1.1;
        //const posY = (mark.y / 100) * imageContainerHeigh;
        const posY = mark.y * 1.7;

        firstPage.drawCircle({
          x: posX + 132, // ajustar según posición de la imagen en el PDF
          y: height - 723 - posY, // ajustar según posición de la imagen en el PDF
          size: circleRadius,
          color: rgb(1, 0, 0),
          borderColor: rgb(0.9, 0.9, 0.9),
          borderWidth: 0.5,
        });
      }
      // 5. Descargar el PDF generado
      /*const pdfBytes = await pdfDoc.save()
        const blob = new Blob([pdfBytes], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'preorden_completa.pdf'
        link.click()*/
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });

      // Crear una URL temporal
      const blobUrl = URL.createObjectURL(blob);

      // Abrir en una nueva ventana
      const printWindow = window.open(blobUrl);

      // Esperar a que se cargue y mandar a imprimir
      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
      };
    },
    initCheckIn(item) {
      this.$router.push({
        name: "checkin",
        query: { item: JSON.stringify(item) },
      });
    },
    printService(id) {
      this.overlay = true;
      axios
        .get("/services/print/" + id)
        .then((response) => {
          this.overlay = false;
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "service_" + id + ".pdf";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        })
        .catch((err) => {
          this.overlay = false;
          //this.msjModal = "Error! " + err;
          //this.$refs["msj-modal"].show();
        });
    },
    getServices() {
      this.overlay = true;
      axios
        .get("/services/getServices")
        .then((response) => {
          this.services = response.data.map((service) => {
            const [datePart, timePart] = service.start.split(" ");
            const [day, month, year] = datePart.split("/").map(Number);
            const [hours = 0, minutes = 0, seconds = 0] =
              timePart?.split(":").map(Number) ?? [];
            const fullYear = year < 100 ? 2000 + year : year;

            const dateObj = new Date(
              fullYear,
              month - 1,
              day,
              hours,
              minutes,
              seconds
            );

            return {
              ...service,
              clientFullName: `${service.client?.first_name ?? ""} ${
                service.client?.last_name ?? ""
              }`.trim(),
              startTimestamp: dateObj.getTime(),
              remainingDays: this.getRemainingDays(service.start),
            };
          });
          this.overlay = false;
        })
        .catch((err) => {
          this.overlay = false;
          //this.msjModal = "Error! " + err;
          //this.$refs["msj-modal"].show();
        });
    },
    openDialog(action, user = null) {
      this.action = action;
      this.clearForm();
      if (this.action === "edit") {
        this.user = {
          id: user.id,
          name: user.name,
          rol: user.roles.length ? user.roles[0].id : null,
          email: user.email,
          password: user.password,
        };
      }
      this.dialogTitle =
        action === "add" ? "Agregar Usuario" : "Editar Usuario";
      //this.user = user ? { ...user } : { id: null, name: "", email: "" };
      this.dialog = true;
      this.overlay = true;
      axios
        .get("/admin/getRoles")
        .then((response) => {
          const rolesOptions = response.data.map((item) => ({
            value: item.id,
            text: item.name,
          }));
          rolesOptions.unshift({
            value: 0,
            text: "Seleccione un Rol...",
          });
          this.roles = rolesOptions;
          this.overlay = false;
        })
        .catch((err) => {
          this.overlay = false;
          this.msjModal = "Error! " + err;
          this.$refs["msj-modal"].show();
        });
    },
    saveUser() {
      if (this.action === "add") {
        this.createUser();
      } else {
        this.updateUser();
      }
      this.dialog = false;
    },
    validateFields() {
      return (
        this.user.name && this.user.email && this.user.password && this.user.rol //&& this.user.area
      );
    },
    createUser() {
      if (!this.validateFields()) {
        this.msjModal = "Hay campos vacíos o sin seleccionar!";
        this.$refs["msj-modal"].show();
        return;
      }

      this.overlay = true;
      axios
        .post("/register", {
          // Aquí debes enviar los datos del formulario
          name: this.user.name,
          role: this.user.rol,
          email: this.user.email,
          password: this.user.password,
        })
        .then((response) => {
          this.getServices();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
        })
        .catch((err) => {
          //console.log(err.response.data.error);
          this.overlay = false;
          this.msjModal = err.response.data.error;
          this.$refs["msj-modal"].show();
        });
    },
    updateUser() {
      this.overlay = true;
      axios
        .post("/admin/update", {
          // Aquí debes enviar los datos del formulario
          id: this.user.id,
          name: this.user.name,
          role: this.user.rol,
          email: this.user.email,
          password: this.user.password,
        })
        .then((response) => {
          this.getServices();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    deleteUser(id) {
      // Simulación de eliminación
      this.services = this.services.filter((u) => u.id !== id);
    },
    clearForm() {
      this.user = {
        id: null,
        name: "",
        rol: 0,
        email: "",
        password: "",
      };
      this.isEdit = false;
    },
    drawTextAt(page, text, x, y, font, size = 9) {
      page.drawText(text, {
        x,
        y,
        size,
        font,
        color: rgb(0, 0, 0),
      });
    },

    drawDate(page, date, height, font) {
      const [day, month, year] = date.split("/");
      this.drawTextAt(page, day, 335, height - 48, font);
      this.drawTextAt(page, month, 370, height - 48, font);
      this.drawTextAt(page, year, 415, height - 48, font);
    },
    drawDateEstimated(page, date, height, font) {
      const [day, month, year] = date.split("/");
      this.drawTextAt(page, day, 485, height - 48, font);
      this.drawTextAt(page, month, 520, height - 48, font);
      this.drawTextAt(page, year, 565, height - 48, font);
    },
    drawTimeEstimated(page, time, height, font) {
      const [hour, minute] = time.split(":");
      this.drawTextAt(page, hour, 485, height - 68, font);
      this.drawTextAt(page, minute, 520, height - 68, font);
    },
    drawDateDelivered(page, date, height, font) {
      const [day, month, year] = date.split("/");
      this.drawTextAt(page, day, 485, height - 88, font);
      this.drawTextAt(page, month, 520, height - 88, font);
      this.drawTextAt(page, year, 565, height - 88, font);
    },
    drawTimeDelivered(page, time, height, font) {
      const [hour, minute] = time.split(":");
      this.drawTextAt(page, hour, 485, height - 108, font);
      this.drawTextAt(page, minute, 520, height - 108, font);
    },
    drawTime(page, time, height, font) {
      const [hour, minute] = time.split(":");
      this.drawTextAt(page, hour, 335, height - 68, font);
      this.drawTextAt(page, minute, 370, height - 68, font);
    },
    technicianStart(page, hourMinute, height, font) {
      this.drawTextAt(page, hourMinute, 372, height - 105, font);
    },
    technicianEnd(page, hourMinute, height, font) {
      this.drawTextAt(page, hourMinute, 432, height - 105, font);
    },
    drawClientInfo(page, client, height, font) {
      this.drawTextAt(
        page,
        `${client.first_name} ${client.last_name ?? ""}`,
        115,
        height - 135,
        font
      );
      this.drawTextAt(page, client.phone ?? "", 85, height - 160, font);
      this.drawTextAt(page, client.email ?? "", 68, height - 180, font);
      this.drawTextAt(page, client.cuit ?? "", 338, height - 180, font);
    },

    drawVehicleInfo(page, vehicle, km, height, font) {
      this.drawTextAt(page, vehicle.model, 340, height - 135, font);
      this.drawTextAt(page, vehicle.plate ?? "", 530, height - 135, font);
      this.drawTextAt(page, km.toString(), 443, height - 150, font);
    },

    drawCircleOption(
      page,
      condition,
      xTrue,
      xFalse,
      y,
      radius,
      borderColor = rgb(0, 0, 0)
    ) {
      page.drawEllipse({
        x: condition ? xTrue : xFalse,
        y,
        xScale: radius,
        yScale: radius,
        borderColor,
        borderWidth: 1,
      });
    },

    drawRequests(page, requests, height, font) {
      let posY = 226;
      let total = 0;
      for (const item of requests) {
        posY += 42;
        this.drawTextAt(page, item.observation, 63, height - posY, font);
        this.drawTextAt(
          page,
          item.value ? item.value.toString() : "",
          530,
          height - posY,
          font
        );
        total += item.value ? item.value : 0;
      }
      //TOTAL
      this.drawTextAt(page, total.toString(), 550, height - 655, font);
    },

    drawObservations(page, observations, height, font) {
      let posY = 792;
      for (const obs of observations) {
        posY += 12;
        this.drawTextAt(
          page,
          obs.observation.toString(),
          48,
          height - posY,
          font
        );
      }
    },

    drawVehicleStateOptions(page, state, height) {
      this.drawCircleOption(
        page,
        state.isVehicleDirty,
        54,
        74,
        height - 756,
        7
      );
      this.drawCircleOption(page, state.hasBelongings, 54, 74, height - 785, 7);
      this.drawCircleOption(
        page,
        state.removesUsedParts,
        54,
        74,
        height - 888,
        7
      );
    },
  },
};
</script>

<style scoped>
/* Anchos por columna */
.custom-table >>> .col-id {
  width: 5%;
}
.custom-table >>> .col-client {
  width: 12%;
}
.custom-table >>> .col-email {
  width: 15%;
}
.custom-table >>> .col-phone {
  width: 10%;
}
.custom-table >>> .col-vehicle {
  width: 10%;
}
.custom-table >>> .col-plate {
  width: 10%;
}
.custom-table >>> .col-remaining {
  width: 8%;
}
.custom-table >>> .col-start {
  width: 10%;
}
.custom-table >>> .col-status {
  width: 10%;
}
.custom-table >>> .col-actions {
  width: 10%;
}

.custom-table {
  font-size: 12px !important;
  table-layout: fixed; /* importante */
  width: 100%;
}

.custom-table >>> table {
  width: 100%;
}

.custom-table >>> th,
.custom-table >>> td {
  font-size: 12px !important;
  padding: 6px 10px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100px; /* valor por defecto, puede sobrescribirse en columnas específicas */
}

.custom-table >>> td > div,
.custom-table >>> th > div {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

/* Columna específica: cliente */
.custom-table >>> .col-client {
  max-width: 150px !important;
  width: 150px !important;
}

/* Columna específica: vehículo */
.custom-table >>> .col-vehicle {
  max-width: 120px !important;
  width: 120px !important;
}

/* Columna específica: fecha */
.custom-table >>> .col-start {
  max-width: 100px !important;
  width: 100px !important;
}

/* Columna específica: estado */
.custom-table >>> .col-status {
  max-width: 100px !important;
  width: 100px !important;
}

/* Columna específica: acciones */
.custom-table >>> .col-actions {
  max-width: 130px !important;
  width: 130px !important;
}

/* Input de búsqueda reducido */
.small-input .v-input__control {
  height: 30px !important;
  font-size: 9pt;
  padding: 4px 8px !important;
}
.small-input .v-label {
  font-size: 0.75rem;
  top: -6px;
}

/* Adaptación para pantallas chicas */
@media (max-width: 500px) {
  .custom-table {
    table-layout: fixed !important;
  }

  .custom-table >>> td,
  .custom-table >>> th {
    font-size: 11px !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }
}
</style>
